// Angular Core
import { Component, ViewChild } from '@angular/core';

import { interval, Subscription } from 'rxjs';

import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'ld-session-timeout-warning',
  templateUrl: './session-timeout-warning.component.html',
  styleUrls: ['./session-timeout-warning.component.css']
})
export class SessionTimeoutWarningComponent {

  @ViewChild('sessionTimeoutWarningModal') sessionTimeoutWarningModal;

  private logOffCountdown: number; /* seconds */
  private logOffCountdownInterval: number = 1000; /* in milliseconds */
  private logOffCountdownListener: Subscription;
  public minutes: number;
  public seconds: number;

  constructor(private authService: AuthService) { }

  ngOnInit() {

    this.authService.inactivityTimer
      .subscribe(
        () => {

          this.logOffCountdown = 600  /* in seconds */;

          // Start the log off countdown
          const observable = interval(1000 /* ms */);
          this.logOffCountdownListener = observable.subscribe(
            () => {
              this.logOffCountdown -= 1;
              this.minutes = Math.trunc(this.logOffCountdown / 60);
              this.seconds = this.logOffCountdown % 60;

              if (this.logOffCountdown <= 0) {
                this.logOff();
              }
            });

        this.sessionTimeoutWarningModal.modal.show();
      });
  }

  public logOff(): void {
    this.cleanupLogOffCountdownListener();
    this.sessionTimeoutWarningModal.close();
    this.authService.logout();
  }

  public stayLoggedIn(): void {
    this.cleanupLogOffCountdownListener();
    this.sessionTimeoutWarningModal.close();
    this.authService.stayLoggedIn();
  }

  private cleanupLogOffCountdownListener(): void {
    if (this.logOffCountdownListener) {
      this.logOffCountdownListener.unsubscribe();
    }
  }
}
